var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"pa-2":"","xs12":""}},[_c('Chatbot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }